
<template>
  <div class="embla" ref="emblaRef">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { emblaCarouselVue } from '@oatsovernight/storybook'
import { onMounted, watch } from 'vue'

const props = defineProps({
  options: {
    type: Object,
    default: () => ({})
  }
})

const [ emblaRef, emblaApi ] = emblaCarouselVue(props.options)
console.log('emblaRef', emblaRef)
console.log('emblaApi', emblaApi)

onMounted(() => {
  console.log('onMounted')
  console.log('emblaApi.value', emblaApi.value)
  if (emblaApi.value) {
    console.log('onMounted', true, emblaApi.value)
    console.log(emblaApi.value.slideNodes()) // Access API
  }
})

watch(emblaApi, () => {
  // console.log('emblaApi', emblaApi)
})

watch(emblaRef, () => {
  // console.log('emblaRef', emblaRef)
})
</script>

<style>
  .embla {
    overflow: hidden;
  }
  .embla__container {
    display: flex;
  }
  .embla__slide {
    flex: 0 0 100%;
    min-width: 0;
  }
</style>